import api from "@/services/api"
import { UserStatusScheduleView } from "@/types/userSchedules"
import { UserStatus } from "@/types/userStatus"

class ApiUserStatus {
	private get axios () { return api.getAxios() }

	public async userStatusList (): Promise<UserStatus[]> {
		const result = await this.axios.get("/userStatus")
		return result.data
	}

	public async userStatusSave (userStatus: UserStatus): Promise<string> { return (await this.axios.post("/userStatus", userStatus)).data }
	public async userStatusDelete (userStatus: UserStatus): Promise<void> { await this.axios.delete(`/userStatus/${userStatus.id}`) }

	public async userStatusScheduleGet (userId: string): Promise<UserStatusScheduleView[]> {
		return (await this.axios.get(`/userStatus/schedule/${userId}`)).data
	}

	public async userStatusScheduleSave (userStatusView: UserStatusScheduleView): Promise<UserStatusScheduleView> {
		return (await this.axios.post("/userStatus/schedule", userStatusView)).data
	}

	public async upcomingSchedules (days: number, userIds: string[]): Promise<UserStatusScheduleView[]> {
		return (await this.axios.post("/userStatus/upcoming", userIds, {
			params: {
				days
			}
		})).data
	}

	public async userStatusScheduleDelete (userStatusView: UserStatusScheduleView, newStatusId: string | null = null): Promise<void> {
		return (await this.axios.delete(`/userStatus/schedule/${userStatusView.id}`, {
			params: {
				newStatusId
			}
		})).data
	}
}

const apiUserStatus = new ApiUserStatus()
export default apiUserStatus
